import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda} from "@commons/core.slice";
import AziendaNavContainer from "../../features/azienda/AziendaNavContainer";
import React, {useEffect, useMemo, useState} from "react";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Tab} from "@headlessui/react";
import {useEditor} from "../../core/editor";
import {useLazyGetAziendaQuery, useUpdateAziendaMutation} from "@commons/features/azienda/aziendaGeneralita.api";
import MappingAziendaEditor from "./tabs/formMapping";
import GeneralitaAziendaEditor from "./tabs/formGeneralita";
import InquadramentoAziendaEditor from "./tabs/formInquadramento";
import AmbitiAziendaEditor from "./tabs/formAmbiti";
import FestivitaAziendaEditor from "./tabs/formFestivita";
import CdicGruppiEditor from "./tabs/formCdiC&Gruppi";
import FornitoriEditor from "./tabs/formFornitori";
import VarieEditor from "./tabs/formVarie";
import {toastAsError} from "@utilities/toastAsError";

const AziendaGeneralitaPage: React.FC<{}> = () => {
    const dispatch = useAppDispatch();
    const generalita = useMemo(() => {
        return {
            domAmm: {}, sedeLegale: {},
            idAziendaCDIC: 0, idAziendaInps: 0, idAziendaInail: 0, idAziendaBanche: 0,
            settoreCCNL: '', codContrattoCCNL: '', codContrattoUNILAV: '', codContrattoCCNLDirigenti: '', codContrattoUNILAVDirigenti: '', motivoChiusura: 0,
            inizioFY: 0, codEntePrevidenziale: '',
            idGestioneInail: 0, idSedeInail: 0, codGiustificativoFS: '', chiusuraAziendale1: {}, chiusuraAziendale2: {},
            santoPatrono: {}, pva: {}, codGiustificativoFC: '', meseFC: 0, codGiustificativoFS_4_11: '',
        } as AziendaRecord
    }, []);

    const azienda: AziendaRecord | null = useAppSelector(selectAzienda);

    const [tabIndex, setTabIndex] = useState<number>(0);

    const [getTrigger, result, promiseInfo] = useLazyGetAziendaQuery();
    const [updateTrigger, updateResult] = useUpdateAziendaMutation();
    const {resource, cancel, URI, edit, saveResource} = useEditor<AziendaRecord>(undefined, undefined, updateTrigger)

    useEffect(() => {
        if (azienda) {
            getTrigger({idAzienda: azienda.idAzienda}, false).then((res) => {
                if (res && res.isSuccess) {
                    console.log("set resource!");
                    edit(res.data, res.data.URI!);
                } else if (res.isError) {
                    if ('data' in res.error) {
                        // @ts-ignore
                        const message = res.error.data.message;
                        toastAsError(message);
                    } else
                        toastAsError("Errore generico!");
                }
            })
        }
    }, [azienda, getTrigger,])
    const onCancel = () => {
        edit(resource!, resource!.URI!);
    }


    return (<>
        <AziendaNavContainer>
            {azienda &&
                <Tab.Group selectedIndex={tabIndex} onChange={(index) => setTabIndex(index)}>
                    <Tab.List className="tab-list">
                        <Tab className="tab">Propriet&agrave;</Tab>
                        <Tab className="tab">ID e codifiche</Tab>
                        <Tab className="tab">Inquadramento</Tab>
                        <Tab className="tab">Ambiti</Tab>
                        <Tab className="tab">Festivit&agrave;</Tab>
                        <Tab className="tab">CdiC & Gruppi</Tab>
                        <Tab className="tab">Fornitori</Tab>
                        <Tab className="tab">Varie</Tab>
                    </Tab.List>
                    <Tab.Panels className="tab-panels">
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <GeneralitaAziendaEditor
                                    defaultValues={generalita}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/proprieta')}
                                ></GeneralitaAziendaEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <MappingAziendaEditor
                                    defaultValues={generalita}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/mapping')}
                                ></MappingAziendaEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <InquadramentoAziendaEditor
                                    defaultValues={generalita}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/inquadramento')}
                                ></InquadramentoAziendaEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <AmbitiAziendaEditor
                                    defaultValues={{} as AziendaRecord}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/ambitoApplicativo')}
                                ></AmbitiAziendaEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <FestivitaAziendaEditor
                                    defaultValues={generalita}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/festivita')}
                                ></FestivitaAziendaEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <CdicGruppiEditor
                                    defaultValues={{} as AziendaRecord}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/tabelle')}
                                ></CdicGruppiEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <FornitoriEditor
                                    defaultValues={{} as AziendaRecord}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/fornitori')}
                                ></FornitoriEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <p className="text-xs">URI: {resource.URI}</p>
                                <VarieEditor
                                    defaultValues={generalita}
                                    resource={resource}
                                    onCancel={onCancel}
                                    onSubmit={(r) => saveResource(r, undefined, r.URI + '/varie')}
                                ></VarieEditor>
                            </div>}
                        </Tab.Panel>
                    </Tab.Panels>
                </Tab.Group>}
        </AziendaNavContainer>
    </>)
}

export interface AziendaEditorProps {
    defaultValues: AziendaRecord,
    resource: AziendaRecord,
    onSubmit: (formData: AziendaRecord) => void,
    onCancel: () => void,
}

export default AziendaGeneralitaPage;